/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailsregistrationnumberplaceholder4Inputs */

const en_companydetailsregistrationnumberplaceholder4 = /** @type {(inputs: Companydetailsregistrationnumberplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. FN 123456a`)
};

const de_companydetailsregistrationnumberplaceholder4 = /** @type {(inputs: Companydetailsregistrationnumberplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. FN 123456a`)
};

/**
* | output |
* | --- |
* | "e.g. FN 123456a" |
*
* @param {Companydetailsregistrationnumberplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailsregistrationnumberplaceholder4 = /** @type {((inputs?: Companydetailsregistrationnumberplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailsregistrationnumberplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailsregistrationnumberplaceholder4(inputs)
	return de_companydetailsregistrationnumberplaceholder4(inputs)
});
export { companydetailsregistrationnumberplaceholder4 as "companyDetailsRegistrationNumberPlaceholder" }